import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161b28f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sensitiveDataItem" }
const _hoisted_2 = { class: "itemLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_toggle_button, {
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeConsent($event))),
      sync: true,
      value: _ctx.value,
      width: 52,
      height: 24,
      speed: 200,
      color: {checked: '#34b76f', unchecked: '#94a7d1'}
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1)
  ]))
}